import {
  ADDON_ID,
  EVENTS
} from "./chunk-QUP5TB6E.mjs";

// src/color-mode/ColorModeTool.tsx
import { IconButton } from "@storybook/components";
import { addons, useAddonState } from "@storybook/manager-api";
import { jsx, jsxs } from "react/jsx-runtime";
var MoonIcon = () => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", focusable: "false", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M21.4,13.7C20.6,13.9,19.8,14,19,14c-5,0-9-4-9-9c0-0.8,0.1-1.6,0.3-2.4c0.1-0.3,0-0.7-0.3-1 c-0.3-0.3-0.6-0.4-1-0.3C4.3,2.7,1,7.1,1,12c0,6.1,4.9,11,11,11c4.9,0,9.3-3.3,10.6-8.1c0.1-0.3,0-0.7-0.3-1 C22.1,13.7,21.7,13.6,21.4,13.7z"
  }
) });
var SunIcon = () => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", focusable: "false", children: /* @__PURE__ */ jsxs(
  "g",
  {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "2",
    fill: "none",
    stroke: "currentColor",
    children: [
      /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "5" }),
      /* @__PURE__ */ jsx("path", { d: "M12 1v2" }),
      /* @__PURE__ */ jsx("path", { d: "M12 21v2" }),
      /* @__PURE__ */ jsx("path", { d: "M4.22 4.22l1.42 1.42" }),
      /* @__PURE__ */ jsx("path", { d: "M18.36 18.36l1.42 1.42" }),
      /* @__PURE__ */ jsx("path", { d: "M1 12h2" }),
      /* @__PURE__ */ jsx("path", { d: "M21 12h2" }),
      /* @__PURE__ */ jsx("path", { d: "M4.22 19.78l1.42-1.42" }),
      /* @__PURE__ */ jsx("path", { d: "M18.36 5.64l1.42-1.42" })
    ]
  }
) });
var ColorModeTool = () => {
  const isDarkMode = localStorage.getItem("chakra-ui-color-mode") === "dark";
  const [darkMode, setDarkMode] = useAddonState(
    `${ADDON_ID}/dark-mode`,
    isDarkMode
  );
  const channel = addons.getChannel();
  const toggleDarkMode = () => {
    channel.emit(EVENTS.TOGGLE_COLOR_MODE, !darkMode ? "dark" : "light");
    setDarkMode(!darkMode);
  };
  return (
    /* @ts-ignore */
    /* @__PURE__ */ jsx(
      IconButton,
      {
        active: darkMode,
        title: `Set color mode to ${darkMode ? "light" : "dark"}`,
        onClick: toggleDarkMode,
        content: "",
        rel: "",
        rev: "",
        children: darkMode ? /* @__PURE__ */ jsx(SunIcon, {}) : /* @__PURE__ */ jsx(MoonIcon, {})
      }
    )
  );
};

export {
  ColorModeTool
};
